module.exports = __webpack_public_path__ + "static/media/personal_folder_tip_3.f1585c84.png";